// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Yig2-","footer":"ReportModalFilter_footer__1K0dy"};